import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from '@/App.vue'
import router from '@/router'
import pinia from '@/stores'
import VueScrollTo from 'vue-scrollto'
import 'virtual:uno.css'
import 'virtual:svg-icons-register'
import '@/styles/app.less'
import '@/styles/var.less'
import { gameIndexApi } from '@/api/home'
import { initConfigApi } from '@/api/profile/userInfo/index'

import { i18n } from '@/utils/i18n'
import SvgIcon from '@/components/SvgIcon/index.vue'

/**
 * skinTheme 换肤默认主题
 */
import '@/styles/skinTheme/202601/theme.less' // 换肤默认主题

// Vant 桌面端适配
import { Lazyload } from 'vant'
import '@vant/touch-emulator'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

const scrollOptions = {
  container: 'body', //滚动的容器
  duration: 500, //滚动时间
  easing: 'ease', //缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true, // 是否要在y轴上滚动
}

const app = createApp(App)
const head = createHead()
app.use(Lazyload)
app.use(VueScrollTo, scrollOptions)
app.use(head)
app.use(router)
app.use(pinia)
app.use(i18n)
app.component('SvgIcon', SvgIcon)

async function initializeApp() {
  // 选用当前主题
  try {
    document.documentElement.setAttribute('data-theme', 'theme-color')
  } catch (error) {
    console.log('选用当前主题错误:', error)
  }

  const response = await fetch('/config.json', { cache: 'no-store' })
  const localConfig = await response.json()
  if (localConfig) {
    localStorage.setItem('localConfig', JSON.stringify(localConfig))
    try {
      // 注入主题变量
      Object.entries(localConfig.themeColors || {}).forEach(([name, value]) => {
        if (name.startsWith('--') && typeof value === 'string') {
          document.documentElement.style.setProperty(name, value)
        }
      })
      // 初始化配置
      const { data, code } = await initConfigApi()
      if (code == 1) {
        localStorage.setItem('initConfig', JSON.stringify(data))
      }
    } catch (error) {
      console.log('initConfig - error:', error)
      // 阻断渲染，显示错误信息
      document.body.innerHTML = `
      <div style="padding:40px;text-align:center;color:#fff;background:#000">
        init error : <br/>${error.message}
      </div>
    `
      return // ⛔ 不执行 app.mount
    } finally {
      app.mount('#app')
    }
  } else {
    console.log('未找到 config.json 文件')
  }
}

initializeApp()
// 修改 router.isReady() 调用
router.isReady().then(() => {
  // 确保只调用一次初始化
})
